import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePCrmInvoiceTypes, PCrmInvoiceType } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<PCrmInvoiceType>
      useData={usePCrmInvoiceTypes}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
